import { RouteRecordRaw } from 'vue-router'

const chat: Array<RouteRecordRaw> = [
    {
        path: '/ai',
        meta: {
            title: "聊天"
        },
        component: () => import("@/views/ai/list.vue")
    },
    {
        path: '/chatDoctor',
        meta: {
            title: "会话记录"
        },
        component: () => import("@/views/ai/index.vue")
    }
];
export default chat;